module.exports = __webpack_public_path__ + "img/hand-point-down.4abb01d2.svg";